import * as React from "react";
import { Button } from "semantic-ui-react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

interface Props {
    task: TaskModel;
    handleCreateMeeting: () => void;
    creatingMeeting: boolean;
}

export const CreateVideoMeetingButton: React.FunctionComponent<Props> = (props: Props) => {
    return (
        <Button
            className="video-meetings-dropdown-button"
            color="blue"
            content="Create New Meeting Link"
            icon="video"
            labelPosition="right"
            onClick={props.handleCreateMeeting} disabled={props.creatingMeeting}
        />
    );
};
